import { Component } from '@angular/core';
import { column1ExtendedItems, mainFooterStacks, pressFooterStack } from '../../config/footer.config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  mainFooterStacks = mainFooterStacks;
  pressFooterStack = pressFooterStack;
  column1ExtendedItems = column1ExtendedItems;
  currentYear = new Date().getFullYear();
}
